import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_feron-collection/artifacts/41yxnxq7_Untitled%20design.webp';

// Variants: 'header' (default), 'footer', 'auth', 'icon'
const Logo = ({ variant = 'header', className = '', linkTo = '/' }) => {
  const dims = {
    header: 'h-14 md:h-16',
    footer: 'h-16',
    auth: 'h-20',
    icon: 'h-10'
  }[variant] || 'h-14';

  const img = (
    <img
      src={LOGO_URL}
      alt="Feron"
      className={`${dims} w-auto object-contain ${className}`}
      style={{ mixBlendMode: variant === 'auth' ? 'screen' : 'normal' }}
      loading="eager"
    />
  );

  if (!linkTo) return img;
  return <Link to={linkTo} className="inline-flex items-center">{img}</Link>;
};

export default Logo;
export { LOGO_URL };
